<template>
    <header class="text-center mb-4">
        <h2 class="skin-page-heading">Lump Sums and Tax</h2>
    </header>

    <div class="row">
        <div class="col-md-5 mx-auto text-center">
            <p>
                This is coming soon to help you reduce and manage tax on regular payments and lump sums. This will be available for Guiide.auto customers to help manage their automated retirement plan.
            </p>
        </div>
    </div>
</template>
